// components
import Bio from "../Bio";

// assets
import bioImg from "../../../assets/images/MichaelWeidner.jpg";

const MichaelWBio = (props) => {
  const bioData = {
    title: "Michael Weidner",
    title2: "Chief Financial Officer",
    hashName: "michael-weidner",
    bio1: `Mike Weidner has served as our Chief Financial Officer and Treasurer and as Chief Financial Officer and Treasurer of our Sponsor and our Advisor since July 2025. Mr. Weidner joined HMC Capital Limited (ASX: HMC) (“HMC Capital”) as the Head of Finance – US in June 2025, overseeing the finance function across HMC’s US portfolio. Prior to joining HMC Capital, Mr. Weidner worked at Macquarie Group (ASX: MQG) (“Macquarie”), a global investment bank and asset manager headquartered in Australia, from June 2013 to June 2025 in their New York office. Mr. Weidner worked in various roles with a focus on financial control, technical accounting, and principal transaction advisory within Macquarie’s Financial Management group, including, most recently, as the Head of Finance in the US for the Macquarie Capital business from March 2022 to June 2025. Prior to that role, from July 2020 to March 2022, Mr. Weidner served as a Vice President of Financial Control at Macquarie. Prior to joining Macquarie, Mr. Weidner worked for Crowe Horwath LLP, a public accounting firm, in their audit, tax, and transaction advisory service practice from 2006 to 2013. Mr. Weidner graduated from Loyola University in Maryland in May 2006 and holds a Bachelor of Science in Business Administration. He is a licensed Certified Public Accountant in the state of New York.`,
  };
  return (
    <Bio
      srcImg={bioImg}
      title1={bioData.title}
      title2={bioData.title2}
      hashName={bioData.hashName}
      bio1={bioData.bio1}
      closeBio={props.closeBio}
    />
  );
};

export default MichaelWBio;
